import { render, staticRenderFns } from "./CardRefCo.vue?vue&type=template&id=15079234"
import script from "./CardRefCo.vue?vue&type=script&lang=js"
export * from "./CardRefCo.vue?vue&type=script&lang=js"
import style0 from "./CardRefCo.vue?vue&type=style&index=0&id=15079234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports